export const DependencyTypes = {
  FS: 'FS', // finish-to-start
  SS: 'SS', // start-to-start
  FF: 'FF', // finish-to-finish
  SF: 'SF', // start-to-finish
};
